module.exports = __webpack_public_path__ + "static/media/banner_novios.ef1c2dbf.jpg";